// 筛选器选择internal时，接口要多传一个字段
const PRECONDITION = 'internal';

export {
  PRECONDITION,
}
